import React, { useContext } from 'react'
import RightContent from 'modules/react/signup/RightContent'
import LeftContent from 'modules/react/signup/LeftContent'
import SignupContext from 'modules/react/signup/SignupContext'
import WhenStep from 'modules/react/signup/conditionals/WhenStep'
import FormElementError from 'modules/react/signup/FormElementError'
import Step1RightContent from 'modules/react/signup/gsk/Step1RightContent'
import NewsletterCheckbox from 'modules/react/signup/NewsletterCheckbox'
import Step1RightContentDynamic from 'modules/react/signup/Step1RightContentDynamic'

export default function SignupContent ({ withBackButton = false }) {
  const signupContext = useContext(SignupContext)

  const { setFormValue, submit, restUrls, goBack, setEnterCallback, useCustomRightContent } = signupContext

  React.useEffect(() => {
      setEnterCallback(() => completeSignup)
    }, []
  )

  const completeSignup = () => {
    submit(restUrls.gsk?.signup || restUrls.signup)
      .then((response) => {
        if (response.data?.location) {
          window.location.href = response.data.location
        }
      })
  }

  return (
    <>
      <WhenStep is={1}>
        <LeftContent>
          <div className="title title--h3">Tilmeld dig gymnasial supplering</div>
          <div className="wysiwyg">Al tilmelding til vores gymnasiale suppleringskurser foregår hos Odense Katedralskole. Derfor sender vi dig videre til deres tilmeldingsside.
          </div>

          <div className="button-section button-section--modal-group">
            {withBackButton && (
              <button className="inline-button inline-button--prim inline-button--back"
                      onClick={goBack}>Tilbage</button>
            )}
            <button className="button button--next" onClick={completeSignup}>
              Du sendes videre
            </button>
          </div>
        </LeftContent>
        <RightContent>
          {useCustomRightContent ? <Step1RightContentDynamic/> : <Step1RightContent/>}
        </RightContent>
      </WhenStep>
    </>
  )
}